<span mat-dialog-title>{{ data.title }}</span>
<mat-dialog-content class="mat-typography" class="flex-container">
  <ul>
    <li *ngFor="let msg of data.messages">{{ msg }}</li>
  </ul>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button [mat-dialog-close]="true">Close</button>
</mat-dialog-actions>
